// extracted by mini-css-extract-plugin
module.exports = {"content":"content--3hgGE","downloadCSV":"downloadCSV--2N1Vb","closeIcon":"closeIcon--NO3vz","byIngredientsBtn":"byIngredientsBtn--3fivw"};